import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminMediaEventsMediaEventRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ media_event_id }) {
    const { content } = await this.store.request(
      findRecord('media-event', media_event_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
